<template>
  <div class="page download">
    <download-cover v-if="isShowMask" />
    <ios-download v-model="downloadVisible"></ios-download>
  </div>
</template>

<script>
import DownloadCover from '@/components/download-cover'
import IosDownload from '@/components/ios-download'

export default {
  name: 'downloadMiddle',
  components: {
    DownloadCover,
    IosDownload
  },
  data () {
    return {
      downloadVisible: false
    }
  },
  async created () {
    this.downloadApp()
    this.back()
  }
 
}
</script>